import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NgControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { IShopOptionsFormValue } from '@x/ecommerce-shop/app/core/product/components/product-options-form/product-options-form.model';
import { IShopProductOption } from '@x/ecommerce/shop-client';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'x-product-options-form',
  templateUrl: './product-options-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-product-options-form' },
})
export class ProductOptionsFormComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private _destroy$ = new Subject<void>();
  private _options: IShopProductOption[];

  private _onChange: any = () => {};
  private _onTouched: any = () => {};

  @Input() set options(options: IShopProductOption[]) {
    options.forEach((option) => {
      this.formGroup.addControl(option.name, new FormControl(null, Validators.required));
    });

    this._options = options;
  }

  get options() {
    return this._options;
  }

  formValue: IShopOptionsFormValue;
  formGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    @Optional()
    ngControl: NgControl,
  ) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.formGroup.valueChanges
      .pipe(
        tap((v) => {
          if (this.formGroup.valid) {
            this._onChange(v);
            this._onTouched(v);
          }
        }),
        takeUntil(this._destroy$),
      )
      .subscribe();

    this.formGroup.patchValue(this.formValue);
  }

  writeValue(formValue: IShopOptionsFormValue): void {
    if (!formValue) return;
    this.formValue = { ...formValue };
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  getControlByName(name: string): UntypedFormControl | null {
    return this.formGroup.get(name) as UntypedFormControl;
  }
}
